import Input from 'components/molecules/Input';
import SelectKeywords from 'components/molecules/SelectKeywords';
import { ActionTemplateConfig } from 'utils/gloo-types';

interface KeywordTemplateConfigProps {
  template?: any;
  handleChange: (data: any) => void;
  handleForm: (data: any) => void;
}
function KeywordTemplateConfig({ template, handleChange, handleForm }: KeywordTemplateConfigProps) {
  const templateConfig = template.config as ActionTemplateConfig;

  const updateConfigProperty = (key, value) => {
    handleChange((prevState) => {
      const config = prevState.config;
      config[key] = value;

      return {
        ...prevState,
        config,
      };
    });

    handleForm((prevState) => {
      const config = prevState.config;
      config[key] = value;

      return {
        ...prevState,
        config,
      };
    });
  };

  return (
    <>
      <Input
        label="Name"
        className="my-2"
        value={templateConfig?.name}
        onChangeText={(t) => {
          updateConfigProperty('name', t);
        }}
        required
      />
      <Input
        label="Response"
        isMultiLine
        rows={4}
        className="my-2"
        value={templateConfig?.response}
        onChangeText={(t) => {
          updateConfigProperty('response', t);
        }}
        required
      />

      <SelectKeywords
        dataDurableId="keywordTemplateConfigSelectId"
        required
        className="border"
        label="Keywords"
        startingKeywords={templateConfig?.keywords}
        onChange={(t) => {
          updateConfigProperty('keywords', t);
        }}
        onCreate={(t) => {
          updateConfigProperty('keywords', [...templateConfig.keywords, t]);
        }}
      />
    </>
  );
}

export default KeywordTemplateConfig;
